import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, Button, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";
import GroupWorkIcon from "@mui/icons-material/GroupWork";

export const CareplanActionbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const currentSection = window.location.pathname.split("/")[2];
  const isChecked =
    currentSection === "default-phases" ||
    currentSection === "new-plan" ||
    currentSection === "estimation";

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (section) => {
    navigate(`/care-plan/${section}`);
    handleClose();
  };

  return (
    <Box>
      <Button
        startIcon={<GroupWorkIcon />}
        endIcon={open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        onClick={handleClick}
        variant="contained"
      >
        {"Actions"}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleSelection("estimation")}>
          {currentSection === "estimation" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          Good Faith Estimation
        </MenuItem>
        <MenuItem onClick={() => handleSelection("new-plan")}>
          {currentSection === "new-plan" ? (
            <CheckIcon style={{ marginRight: 8 }} />
          ) : (
            <Box style={{ width: isChecked ? 32 : 0 }} />
          )}
          New Care Plan
        </MenuItem>
      </Menu>
    </Box>
  );
};
